import React from "react";

import Button from "components/ui/Button";

const pendingData = [
  { label: "0–7 days", count: 18, amount: 4320, color: "var(--color-warning)", probability: "High" },
  { label: "8–15 days", count: 12, amount: 3180, color: "var(--color-accent)", probability: "Medium" },
  { label: "16–30 days", count: 8, amount: 2640, color: "var(--color-error)", probability: "Low" },
  { label: "30+ days", count: 5, amount: 1890, color: "#6B7280", probability: "Very Low" },
];

export default function PaymentPendingSummary() {
  const total = pendingData?.reduce((s, d) => s + d?.amount, 0);
  const totalCount = pendingData?.reduce((s, d) => s + d?.count, 0);

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 shadow-[var(--shadow-sm)]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)]">Payment Pending</h3>
        <div className="text-right">
          <p className="text-sm font-bold text-[var(--color-error)] font-[var(--font-data)]">${total?.toLocaleString()}</p>
          <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">{totalCount} members</p>
        </div>
      </div>
      <div className="space-y-2.5">
        {pendingData?.map((item, i) => (
          <div key={i} className="flex items-center gap-3">
            <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: item?.color }} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium text-[var(--color-foreground)] font-[var(--font-caption)]">{item?.label}</span>
                <span className="text-xs font-semibold text-[var(--color-foreground)] font-[var(--font-data)]">${item?.amount?.toLocaleString()}</span>
              </div>
              <div className="w-full h-1.5 bg-[var(--color-muted)] rounded-full overflow-hidden">
                <div className="h-full rounded-full transition-all" style={{ width: `${(item?.amount / total) * 100}%`, backgroundColor: item?.color }} />
              </div>
              <div className="flex items-center justify-between mt-1">
                <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">{item?.count} members</span>
                <span className="text-xs font-[var(--font-caption)]" style={{ color: item?.color }}>{item?.probability} recovery</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-[var(--color-border)]">
        <Button variant="default" size="sm" fullWidth iconName="DollarSign" iconPosition="left" iconSize={14}>
          Initiate Collection
        </Button>
      </div>
    </div>
  );
}